import React from 'react';
import '../../App.css';
import SlideShow from '../SlideShow';
import {home_images} from "../../home_images";

function Home() {
  return (
    <>
      <SlideShow fadeImages={home_images}  />
    </>
  );
}

export default Home;
